module.exports = __webpack_public_path__ + "img/Screenshot_1.7683e443.png";